import { Injectable } from '@angular/core';
import { BaseApiService } from '../../../common/base-api.service';
import { HttpClient } from '@angular/common/http';
import { SettingsProviderService } from '../../../common/settings-provider.service';
import { Observable } from 'rxjs';
import { ICompanyJobTitle } from '../../../message-models/company-job-title.interface';
import { CompanyJobTitle } from '../../../message-models/company-job-title.class';

@Injectable({
  providedIn: 'root'
})
export class CompanyJobRoleService extends BaseApiService {

  constructor(http: HttpClient) {
    super(http, new SettingsProviderService('ecaApi'), 'CompanyJobTitle');
  }



  getCompanyJobTitlesByCompanyId(companyId: string): Observable<ICompanyJobTitle[]>{
    return this.post<ICompanyJobTitle[]>('GetAllCompanyJobTitles', {companyId});  
  }


  CreateOrUpdateCompanyJobTitle(companyJobTitle: CompanyJobTitle) {
    return this.post<CompanyJobTitle>('CreateOrUpdateCompanyJobTitle', companyJobTitle);
  }


  RemoveCompanyJobTitle(companyJobTitle: CompanyJobTitle) {
    return this.post<CompanyJobTitle>('RemoveCompanyJobTitle', { companyJobTitleId: companyJobTitle.id, companyId: companyJobTitle.companyId});
  }








}
